import { css } from '@emotion/react';

export const padding = (...args) => {
  const paddings =
    typeof args[0] === 'string' && args.length === 1
      ? args[0].split(' ')
      : args;
  const [paddingX, paddingY] = paddings;

  return {
    paddingTop: paddingX,
    paddingBottom: paddingX,
    paddingLeft: paddingY,
    paddingRight: paddingY,
  };
};

export const margin = (...args) => {
  const margins = typeof args[0] === 'string' ? args[0].split(' ') : args;
  const [marginX, marginY] = margins;

  return {
    marginTop: marginX,
    marginBottom: marginX,
    marginLeft: marginY,
    marginRight: marginY,
  };
};

export const verticalAlign = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

export const generateBaseStyles = ({ isFullWidth }) => {
  const styles = [];

  if (isFullWidth) {
    styles.push(css({ width: '100%' }));
  }

  return styles;
};
